/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState } from 'react';
import {
    object, string, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CustomsCardWrapper from '../CustomsCardWrapper/CustomsCardWrapper';

const styles = (theme) => ({
    title: {
        fontSize: 28,
        textAlign: 'center',
        padding: '24px 0px',
    },
    icons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    customs: {
        display: 'flex',
        justifyContent: 'center',
        margin: '30px 0px',
    },
    selectButtonContainer: {
        textAlign: 'center',
        margin: '30px 0',
    },
    selectButton: {
        background: theme.palette.common?.black,
        color: theme.palette.common?.white,
        '&:hover': {
            background: theme.palette.common?.black,
        },
    },
});
const CUSTOMS_VIEWS = {
    SELECT_IMAGE: 'photo',
    SELECT_MESSAGE: 'text',
    SELECT_IMAGE_AND_MESSAGE: 'both',
};
const SelectCelebrationsCustomsCard = ({
    customsCard, classes, setCustomsCardType, dataDictionary,
}) => {
    const [customsType, setCustomsType] = useState(CUSTOMS_VIEWS.SELECT_IMAGE);
    return (
        <>
            <Grid item sm={3} className={classes.icons}>
                {customsType === CUSTOMS_VIEWS.SELECT_MESSAGE ? <ArrowBackIosIcon onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_IMAGE)} /> : null}
                {customsType === CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE ? <ArrowBackIosIcon onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_MESSAGE)} /> : null}
            </Grid>
            <Grid item sm={6} className={classes.customs}>
                <CustomsCardWrapper customsCard={customsCard}>
                    {customsType === CUSTOMS_VIEWS.SELECT_IMAGE
                        ? <Typography variant="h3" className={classes.title}>{dataDictionary?.['Your Photo Here'] || 'Your Photo Here'}</Typography>
                        : null}
                    {customsType === CUSTOMS_VIEWS.SELECT_MESSAGE
                        ? <Typography variant="h3" className={classes.title}>{dataDictionary?.['Your Message Here'] || 'Your Message Here'}</Typography>
                        : null}
                    {customsType === CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE
                        ? (
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="h3" className={classes.title}>{dataDictionary?.['Your Photo Here'] || 'Your Photo Here'}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h3" className={classes.title}>{dataDictionary?.['Your Message Here'] || 'Your Message Here'}</Typography>
                                </Grid>
                            </Grid>
                        )
                        : null}
                </CustomsCardWrapper>
            </Grid>
            <Grid item sm={3} className={classes.icons}>
                {customsType === CUSTOMS_VIEWS.SELECT_IMAGE ? <ArrowForwardIosIcon data-testid="arrowforward-select-image" onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_MESSAGE)} /> : null}
                {customsType === CUSTOMS_VIEWS.SELECT_MESSAGE ? <ArrowForwardIosIcon data-testid="arrowforward-select-msg" onClick={() => setCustomsType(CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE)} /> : null}
            </Grid>
            <Grid item xs={12} className={classes.selectButtonContainer}>
                <Button type="submit" className={classes.selectButton} onClick={() => setCustomsCardType(customsType)}>{dataDictionary?.['SELECT THIS OPTION'] || 'SELECT THIS OPTION'}</Button>
            </Grid>
        </>
    );
};

SelectCelebrationsCustomsCard.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    setCustomsCardType: func.isRequired,
    dataDictionary: object,
};

SelectCelebrationsCustomsCard.defaultProps = {
    dataDictionary: {},
};
export default withStyles(styles)(SelectCelebrationsCustomsCard);
